import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { CommentsResponse } from "../../models/Comment";

export const CommentApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "commentApi",
  endpoints(build) {
    return {
      getComments: build.query<
        CommentsResponse,
        { projectId: number; page: number; size: number, month : any }
      >({
        query: ({ projectId, page, size , month}) => ({
          url: `project-reviews/${projectId}/comments?month=${month}&page=${page}&size=${size}`,
          method: "GET",
        }),
      }),
    };
  },
});

export const { useGetCommentsQuery } = CommentApi;
